import common from "../common";
import Button from "./Button";

export default class SubmitButton extends Button {

    constructor(label = "", css, submit)
    {
        if(css == null) css = {};
        super();

        this.init(label);

        this.initButton(label, submit);
    }

    init(label)
    {
        this.htmlElement = $('<span class="p3-nextButton">' + label + '</span>');
    }
}